import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "carousel-more"
};
const _hoisted_2 = ["src"];
import { ref, computed, onMounted, nextTick, onActivated } from 'vue';
import 'swiper/css/scrollbar';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import constants, { encryptedMarketplaceId } from '@/constants';
import AsinItem from './AsinItem.vue';
import { getAsinBatch } from '@/models/api/detailPageApi';
import { useLess } from '@/models/hooks';
import { swiperDomTouchLogic, jumpInteractionType } from '@/utils/common';
import { useRouter } from 'vue-router';
import { batchGetAsinsData } from '@/utils/landingPageCommon';
const API_MAX_ASINS_LENGTH = 20;
export default {
  __name: 'HorizontalAsinShowCase',
  props: {
    asinItemClass: {
      type: String
    },
    asinIds: {
      type: Array
    },
    asinBadge: {
      type: String
    },
    isShowBuyButton: {
      type: Boolean
    },
    displayQuantity: {
      type: Number
    },
    moreIsShow: {
      type: Boolean
    },
    customTextContent: {
      type: String
    },
    interactionTypeInfo: {
      type: Array
    }
  },
  emits: ['onClickBuyPop'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/landingPage/asinShowcase/TransverseShowcase.less');
    const router = useRouter();
    const asinList = ref([]);
    const asinSwiperItem = ref();
    const swiperRef = ref(null);
    const asinItemStyle = computed(() => {
      return {
        ...(!props.isShowBuyButton && {
          height: 'auto'
        })
      };
    });
    const onSwiper = swiper => {
      swiperRef.value = swiper;
    };
    const swiperDomTouch = () => {
      nextTick(() => {
        var _props$interactionTyp;
        if (!asinSwiperItem.value) {
          return;
        }
        const swiperDomList = asinSwiperItem.value[asinSwiperItem.value.length - 1].swiperRef.value.slides;
        const lastSwiperDom = swiperDomList[swiperDomList.length - 1];
        swiperDomTouchLogic(lastSwiperDom, jumpInteractionType(props === null || props === void 0 ? void 0 : (_props$interactionTyp = props.interactionTypeInfo) === null || _props$interactionTyp === void 0 ? void 0 : _props$interactionTyp[0], router));
      });
    };
    const getAsinList = async () => {
      if (props.displayQuantity === 0 || props.asinIds.length === 0) return;
      let asinIdList = [];
      const length = props.displayQuantity > props.asinIds.length ? props.asinIds.length : props.displayQuantity;
      asinIdList = props.asinIds.slice(0, length);
      if (asinIdList.length > API_MAX_ASINS_LENGTH) {
        try {
          // Fragment request, previous request completed, next request
          batchGetAsinsData(asinIdList, API_MAX_ASINS_LENGTH, asinList);
        } catch (error) {
          console.error(error, 'api---getAsinBatch---error');
        }
      } else {
        try {
          var _data;
          let {
            data
          } = await getAsinBatch({
            ids: asinIdList.join(','),
            marketplace: encryptedMarketplaceId,
            withCache: true
          });
          data = (_data = data) === null || _data === void 0 ? void 0 : _data.filter(i => {
            var _i$availability;
            return i.selectionEligible && ((_i$availability = i.availability) === null || _i$availability === void 0 ? void 0 : _i$availability.status) !== constants.AVAILABILITY_STATUS_ENUM.OUT_OF_STOCK;
          });
          asinList.value.push(...data);
        } catch (error) {
          console.error(error, 'api---getAsinBatch---error');
        }
      }
      swiperDomTouch();
    };
    const onClickBuyPop = item => {
      emit('onClickBuyPop', {
        merchantId: item.merchantId,
        selectedAsin: item.selectedAsin
      });
    };
    onMounted(() => {
      getAsinList();
    });
    onActivated(() => {
      var _swiperRef$value, _swiperRef$value$scro, _swiperRef$value$scro2;
      (_swiperRef$value = swiperRef.value) === null || _swiperRef$value === void 0 ? void 0 : (_swiperRef$value$scro = _swiperRef$value.scrollbar) === null || _swiperRef$value$scro === void 0 ? void 0 : (_swiperRef$value$scro2 = _swiperRef$value$scro.updateSize) === null || _swiperRef$value$scro2 === void 0 ? void 0 : _swiperRef$value$scro2.call(_swiperRef$value$scro);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Swiper), {
        modules: [_unref(Scrollbar)],
        class: "asin-swiper",
        "slides-per-view": "auto",
        ref_key: "swiperRef",
        ref: swiperRef,
        onSwiper: onSwiper,
        watchSlidesProgress: true,
        scrollbar: {
          hide: false
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(asinList.value, (asinItem, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            class: "swiper-slide-item",
            key: asinItem.id,
            ref_for: true,
            ref_key: "asinSwiperItem",
            ref: asinSwiperItem
          }, {
            default: _withCtx(() => [_createVNode(AsinItem, {
              style: _normalizeStyle(asinItemStyle.value),
              class: _normalizeClass([__props.asinItemClass, 'asin-item']),
              asinItem: asinItem,
              asinBadge: __props.asinBadge,
              isShowBuyButton: __props.isShowBuyButton,
              onOnClickBuyPop: onClickBuyPop
            }, null, 8, ["style", "class", "asinItem", "asinBadge", "isShowBuyButton"]), asinList.value.length > 1 && index == asinList.value.length - 1 && __props.moreIsShow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
              src: `${_unref(constants).IMAGE_URL}assets/image/icons/leftArrowBorder.png`
            }, null, 8, _hoisted_2), _createElementVNode("span", null, _toDisplayString(__props.customTextContent), 1)])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["modules"]);
    };
  }
};